import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { http } from "@/lib/api";
import { ArrowLeft, Clock, Loader2 } from "lucide-react";
import FinalCTA from "@/components/home/FinalCTA";

export default function InsightSingle() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setLoading(true);
    http
      .get(`/insights/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setErr(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="pt-40 pb-20 min-h-[50vh] flex items-center justify-center" data-testid="insight-loading">
        <Loader2 className="w-6 h-6 animate-spin text-[#D7141A]" />
      </div>
    );
  }

  if (err || !post) {
    return (
      <div className="pt-40 pb-20 min-h-[50vh]" data-testid="insight-not-found">
        <div className="container-sp text-center max-w-xl mx-auto">
          <div className="overline">Not found</div>
          <h1 className="font-serif text-4xl text-[#0D1B2A] mt-3">Article not found.</h1>
          <Link to="/insights" className="btn-primary mt-8 inline-flex">
            <ArrowLeft className="w-4 h-4" /> Back to Insights
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div data-testid={`page-insight-${post.slug}`}>
      <article className="pt-36 md:pt-40 pb-20">
        <div className="container-sp max-w-3xl">
          <Link to="/insights" className="inline-flex items-center gap-1.5 text-sm text-[#4A5568] hover:text-[#0D1B2A]">
            <ArrowLeft className="w-4 h-4" /> All insights
          </Link>
          <div className="overline mt-8">{post.category}</div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#0D1B2A] mt-3 leading-[1.05]">
            {post.title}
          </h1>
          <div className="flex items-center gap-4 mt-6 text-xs text-[#718096]">
            <span className="inline-flex items-center gap-1.5">
              <Clock className="w-3.5 h-3.5" /> {post.read_time} min read
            </span>
            <span>·</span>
            <span>{new Date(post.created_at).toLocaleDateString()}</span>
          </div>

          {post.cover_image && (
            <div className="mt-10 rounded-2xl overflow-hidden border border-[#E5E3D8]">
              <img src={post.cover_image} alt={post.title} className="w-full h-[420px] object-cover" />
            </div>
          )}

          {post.excerpt && (
            <p className="mt-10 font-serif text-xl text-[#4A5568] leading-relaxed italic border-l-2 border-[#D7141A] pl-5">
              {post.excerpt}
            </p>
          )}

          <div
            className="prose-sp mt-10 text-[#2D3748] leading-[1.8]"
            style={{ fontSize: "1.05rem", whiteSpace: "pre-wrap" }}
            data-testid="insight-content"
          >
            {post.content}
          </div>
        </div>
      </article>
      <FinalCTA />
    </div>
  );
}
